import PaginationCoreUI from './PaginationCoreUI';

export default PaginationCoreUI;
